
interface FortuneDisplayProps {
  fortune: string;
  isVisible: boolean;
}

export default function FortuneDisplay({ fortune, isVisible }: FortuneDisplayProps) {
  if (!isVisible || !fortune) return null;

  return (
    <div className="flex justify-center mb-8 sm:mb-12 px-2 sm:px-4 animate-slideDown">
      <div className="relative max-w-2xl w-full">
        {/* Neon border container */}
        <div className="relative bg-black/60 backdrop-blur-md border-2 sm:border-4 border-pink-400 rounded-lg p-6 sm:p-8 neon-fortune-glow">
          {/* Corner decorations */}
          <div className="absolute top-0 left-0 w-3 sm:w-4 h-3 sm:h-4 border-t-2 sm:border-t-4 border-l-2 sm:border-l-4 border-cyan-400 -translate-x-1 -translate-y-1"></div>
          <div className="absolute top-0 right-0 w-3 sm:w-4 h-3 sm:h-4 border-t-2 sm:border-t-4 border-r-2 sm:border-r-4 border-cyan-400 translate-x-1 -translate-y-1"></div>
          <div className="absolute bottom-0 left-0 w-3 sm:w-4 h-3 sm:h-4 border-b-2 sm:border-b-4 border-l-2 sm:border-l-4 border-cyan-400 -translate-x-1 translate-y-1"></div>
          <div className="absolute bottom-0 right-0 w-3 sm:w-4 h-3 sm:h-4 border-b-2 sm:border-b-4 border-r-2 sm:border-r-4 border-cyan-400 translate-x-1 translate-y-1"></div>

          {/* Fortune text */}
          <div className="relative">
            <div className="text-pink-400 text-3xl sm:text-4xl md:text-5xl leading-none mb-2 sm:mb-3 neon-quote">"</div>
            <p className="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-center font-medium neon-text-fortune px-2 sm:px-4">
              {fortune}
            </p>
            <div className="text-cyan-400 text-3xl sm:text-4xl md:text-5xl leading-none mt-2 sm:mt-3 text-right neon-quote">"</div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-slideDown {
          animation: slideDown 0.6s ease-out;
        }

        .neon-fortune-glow {
          box-shadow: 
            0 0 20px rgba(255, 0, 255, 0.5),
            0 0 40px rgba(255, 0, 255, 0.3),
            inset 0 0 20px rgba(255, 0, 255, 0.1);
        }

        .neon-text-fortune {
          text-shadow: 
            0 0 5px rgba(255, 255, 255, 0.8),
            0 0 10px rgba(255, 0, 255, 0.4);
        }

        .neon-quote {
          text-shadow: 
            0 0 10px currentColor,
            0 0 20px currentColor,
            0 0 30px currentColor;
        }
      `}</style>
    </div>
  );
}
